<ciao-okay-modal
  #checkOutModal
  hidden="true"
  [disabled]="!canOkay(trip, 'checkOut')"
  okayType="checkOut"
  class="btn"
  [tripSummaryContext]="true"
  buttonClass="btn-action-solid"
  [trip]="trip"
></ciao-okay-modal>
<!--
<ciao-okay-modal
  [disabled]="!canOkay(trip, 'okay')"
  okayType="okay"
  class="btn"
  [tripSummaryContext]="true"
  buttonClass="btn-action-solid"
  [trip]="trip"
></ciao-okay-modal> -->
<ciao-okay-modal
  #checkInModal
  hidden="true"
  okayType="checkIn"
  class="btn"
  [tripSummaryContext]="true"
  buttonClass="btn-action-solid"
  [trip]="trip"
></ciao-okay-modal>

<button
  class="large-button checkout"
  *ngIf="trip?.tripStatus === 'Planned'"
  (click)="canCheckout ? checkOutModal.Open() : null"
  [ngClass]="{ disabled: !canCheckout }"
>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.64315 23.7029C5.02236 23.7029 4.49093 23.4819 4.04886 23.0398C3.60678 22.5977 3.38574 22.0663 3.38574 21.4455V5.64364C3.38574 5.02285 3.60678 4.49142 4.04886 4.04934C4.49093 3.60727 5.02236 3.38623 5.64315 3.38623H12.4154C12.7352 3.38623 13.0032 3.4944 13.2196 3.71073C13.4359 3.92707 13.5441 4.19514 13.5441 4.51493C13.5441 4.83473 13.4359 5.1028 13.2196 5.31914C13.0032 5.53547 12.7352 5.64364 12.4154 5.64364H5.64315V21.4455H12.4154C12.7352 21.4455 13.0032 21.5537 13.2196 21.77C13.4359 21.9863 13.5441 22.2544 13.5441 22.5742C13.5441 22.894 13.4359 23.1621 13.2196 23.3784C13.0032 23.5947 12.7352 23.7029 12.4154 23.7029H5.64315ZM19.3851 14.6733H11.2867C10.9669 14.6733 10.6988 14.5651 10.4825 14.3488C10.2661 14.1324 10.158 13.8644 10.158 13.5446C10.158 13.2248 10.2661 12.9567 10.4825 12.7404C10.6988 12.524 10.9669 12.4159 11.2867 12.4159H19.3851L17.2688 10.2995C17.0619 10.0926 16.9584 9.83866 16.9584 9.53767C16.9584 9.23668 17.0619 8.97332 17.2688 8.74757C17.4757 8.52183 17.7391 8.40426 18.0589 8.39485C18.3787 8.38545 18.6515 8.49362 18.8772 8.71936L22.9123 12.7545C23.1381 12.9802 23.2509 13.2436 23.2509 13.5446C23.2509 13.8456 23.1381 14.1089 22.9123 14.3347L18.8772 18.3698C18.6515 18.5955 18.3834 18.7037 18.073 18.6943C17.7626 18.6849 17.4945 18.5673 17.2688 18.3416C17.0619 18.1158 16.9631 17.8478 16.9725 17.5374C16.9819 17.227 17.0901 16.9683 17.297 16.7614L19.3851 14.6733Z"
        fill="currentcolor"
      />
    </svg>

    <span>Check Out</span>
</button>

<button
  class="large-button"
  *ngIf="trip?.tripStatus !== 'Planned'"
  (click)="emitCheckpointEvent()"
>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.347 20.0982C10.9062 20.539 10.1915 20.539 9.75074 20.0982L4.37722 14.7247C3.93643 14.2839 3.93643 13.5693 4.37722 13.1285L4.52342 12.9823C4.96421 12.5415 5.67887 12.5415 6.11965 12.9823L9.75074 16.6134C10.1915 17.0541 10.9062 17.0541 11.347 16.6134L20.9696 6.99074C21.4104 6.54995 22.125 6.54995 22.5658 6.99074L22.712 7.13695C23.1528 7.57774 23.1528 8.29239 22.712 8.73318L11.347 20.0982Z"
        fill="currentcolor"
      />
    </svg>

    <span>I'm Okay</span>
</button>

<button
  class="large-button checkin"
  *ngIf="trip?.tripStatus !== 'Planned'"
  (click)="checkInModal.Open()"
>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4161 23.7029C12.7359 23.7029 13.004 23.5947 13.2203 23.3784C13.4367 23.1621 13.5448 22.894 13.5448 22.5742C13.5448 22.2544 13.4367 21.9863 13.2203 21.77C13.004 21.5537 12.7359 21.4455 12.4161 21.4455H5.64389V5.64364H12.4161C12.7359 5.64364 13.004 5.53547 13.2203 5.31914C13.4367 5.1028 13.5448 4.83473 13.5448 4.51493C13.5448 4.19514 13.4367 3.92707 13.2203 3.71073C13.004 3.4944 12.7359 3.38623 12.4161 3.38623H5.64389C5.02311 3.38623 4.49167 3.60727 4.0496 4.04934C3.60752 4.49142 3.38648 5.02285 3.38648 5.64364V21.4455C3.38648 22.0663 3.60752 22.5977 4.0496 23.0398C4.49167 23.4819 5.02311 23.7029 5.64389 23.7029H12.4161ZM14.476 14.6733H22.5745C22.8943 14.6733 23.1623 14.5651 23.3787 14.3488C23.595 14.1324 23.7032 13.8644 23.7032 13.5446C23.7032 13.2248 23.595 12.9567 23.3787 12.7404C23.1623 12.524 22.8943 12.4159 22.5745 12.4159H14.476L16.5923 10.2995C16.7993 10.0926 16.9027 9.83866 16.9027 9.53767C16.9027 9.23668 16.7993 8.97332 16.5923 8.74757C16.3854 8.52183 16.122 8.40426 15.8022 8.39485C15.4824 8.38545 15.2097 8.49362 14.9839 8.71936L10.9488 12.7545C10.7231 12.9802 10.6102 13.2436 10.6102 13.5446C10.6102 13.8456 10.7231 14.1089 10.9488 14.3347L14.9839 18.3698C15.2097 18.5955 15.4777 18.7037 15.7881 18.6943C16.0985 18.6849 16.3666 18.5673 16.5923 18.3416C16.7993 18.1158 16.898 17.8478 16.8886 17.5374C16.8792 17.227 16.771 16.9683 16.5641 16.7614L14.476 14.6733Z"
        fill="currentcolor"
      />
    </svg>
    <span>Check In</span>
</button>
